<script setup lang="ts">
import type { ConnectedAccounts } from 'pejer/src/tables/ConnectedAccounts'

import { computed } from 'vue'

import { Payment } from 'pejer/src/tables/Payment'
import { Filters, SearchQuery } from '../../types/types'
import AccountDashboard from '../Dashboards/AccountDashboard.vue'
import PaymentDashboard from '../Dashboards/PaymentDashboard.vue'
import HorizontalLine from '../HorizontalLine.vue'

const props = defineProps<{
  connectedAccount?: ConnectedAccounts.Full | null
  platformId?: string
}>()

const accountQuery = computed(() => {
  const q: SearchQuery<ConnectedAccounts.ListItem> = {}
  if (props.connectedAccount?.connectedAccountID) {
    q.connectedAccountID = {
      '=': {
        value: `'${props.connectedAccount.connectedAccountID}'`,
      },
    }
  }
  if (props.platformId) {
    q.platformID = {
      '=': {
        value: `'${props.platformId}'`,
      },
    }
  }

  return { userFilters: q } satisfies Filters<Payment.ListItem>
})

const paymentQuery = computed(() => {
  const q: SearchQuery<Payment.ListItem> = {}
  if (props.connectedAccount?.connectedAccountID) {
    q.connectedAccountIDSeller = {
      '=': {
        value: `'${props.connectedAccount.connectedAccountID}'`,
      },
    }
  }

  if (props.platformId) {
    q.platformID = {
      '=': {
        value: `'${props.platformId}'`,
      },
    }
  }

  return { userFilters: q } satisfies Filters<Payment.ListItem>
})

// const store = usePejerBase()
// async function handleCalendarChange(date: DatePickerRangeObject) {
//   const { start, end } = date as {
//     start: string
//     end: string
//   }

//   const startDate = new Date(start)
//   const endDate = new Date(end)

//   const daysBetween = differenceInDays(endDate, startDate)
// }
</script>
<template>
  <div class="flex flex-col gap-4">
    <slot />
    <PaymentDashboard :query="paymentQuery" />
    <HorizontalLine class="border-slate-200" />
    <AccountDashboard :query="accountQuery" />
  </div>
</template>
